import React from 'react';
import {loadModules} from 'esri-loader';
import "./ContactMapStyle.css"
import {Tooltip} from "@mui/material";

const options = {version: '4.27', css: true};

export class ContactMap extends React.Component {

    constructor(props) {
        super(props);
        this.mapRef = React.createRef();

    }


    componentDidMount() {
        loadModules(['esri/views/MapView', 'esri/Map', "esri/layers/GraphicsLayer", "esri/Graphic"], options)
            .then(([MapView, Map, GraphicsLayer, Graphic]) => {
                const map = new Map({
                    basemap: "dark-gray-vector"
                });

                const view = new MapView({
                    container: this.mapRef.current,
                    map: map,
                    center: [44.71369923210905, 41.72002327938312],
                    zoom: 15,
                    // Disable UI components, zoom and other navigation
                    ui: {
                        components: [] // remove default UI components like zoom controls
                    },
                    // Disable mouse wheel scroll zooming
                    navigation: {
                        mouseWheelZoomEnabled: false // prevents mouse wheel scroll zooming
                    }
                });

                // Disable all other interactions
                view.on("drag", ["all"], function (event) {
                    event.stopPropagation();
                });
                view.on("key-down", function (event) {
                    event.stopPropagation();
                });
                view.on("double-click", function (event) {
                    event.stopPropagation();
                });
                view.on("double-click", ["Shift"], function (event) {
                    event.stopPropagation();
                });
                view.on("drag", ["Shift"], function (event) {
                    event.stopPropagation();
                });
                view.on("mouse-wheel", function (event) {
                    event.stopPropagation();
                });

                const graphicsLayer = new GraphicsLayer();
                const point = {
                    type: "point",
                    longitude: 44.71369923210905,
                    latitude: 41.72002327938312
                };

                const contenttxt = "<div style=';font-family:FiraGoBold, serif;font-size:15px;line-height: 21px;' >" +
                    "<div>თბილისი 0186</div><div style='margin-top:5px;'>ანა პოლიტკოვსკაიას ქ. N8(ყოფ. ჯიქია),   IV სართული</div>" +
                    "</div>";

                const symbol = {
                    type: "picture-marker",
                    url: "img/contactMapIcon.png",
                    width: "42px",
                    height: "42px"
                };
                const pointGraphic = new Graphic({
                    geometry: point,
                    symbol: symbol,
                    popupTemplate: {
                        title: "",
                        content: contenttxt,
                        actions: []
                    }
                });
                graphicsLayer.graphics.add(pointGraphic);
                map.add(graphicsLayer);
            })
    }


    componentWillUnmount() {
        if (this.view) {
            this.view.container = null;
        }
    }

    render() {
        const mapContainerStyle = {
            borderRadius: '60px',
            overflow: 'hidden',
            marginTop: 10
        };
        const lang = localStorage.getItem("lang")
        return (
            <div>
                <Tooltip
                    title={lang === "eng" ? "Click on the map to go to Google Maps" : "Google Maps-ზე გადასვლიშთვის დააჭირეთ რუკას"}
                    placement="top"  // Tooltips are placed on top
                >
                    <div style={mapContainerStyle} className="contact-map-container" ref={this.mapRef}>
                        {this.props.children}
                    </div>
                </Tooltip>
            </div>
        );
    }

}